/** Platform admin: tenants screen (P9). Owned by the tenants screen; fil mirrors every key. */
export const tenants = {
  title: "Tenants",
  subtitle: "Every organization on Sagot — schools, clinics, realty, resorts and LGU pilots.",
  exportAll: "Export all",
  exported: "{{file}} exported · {{count}} rows",
  exportFailed: "The export couldn't finish. Try again.",
  createTenant: "Create tenant",
  stats: {
    label: "Tenant summary",
    total: "Total",
    paying: "Active (paying)",
    mrr: "{{amount}} MRR",
    trial: "On trial / pilot",
    pastDue: "Past due",
    outstanding: "{{amount}} outstanding",
    suspended: "Suspended",
    active: "{{count}} active",
  },
  filters: {
    label: "Filter tenants",
    search: "Search name, domain or owner…",
    plan: "Plan",
    allPlans: "All plans",
    status: "Status",
    allStatuses: "All statuses",
    industry: "Industry",
    allIndustries: "All industries",
    region: "Region",
    allRegions: "All regions",
    reset: "Reset",
  },
  industries: {
    education: "Education",
    school: "Education",
    healthcare: "Clinic",
    clinic: "Clinic",
    real_estate: "Real estate",
    hospitality: "Hospitality",
    government: "Government",
    human_resources: "HR",
    ecommerce: "E-commerce",
    other: "Other",
  },
  bulk: {
    selected_one: "{{count}} selected",
    selected_other: "{{count}} selected",
    exportCsv: "Export CSV",
    emailOwners: "Email owners",
    addTag: "Add tag",
    clear: "Clear selection",
    unavailable: "Not available yet",
  },
  table: {
    label: "Tenant directory",
    selectAll: "Select all tenants on this page",
    select: "Select {{tenant}}",
    tenant: "Tenant",
    industry: "Industry",
    plan: "Plan",
    status: "Status",
    agents: "Agents",
    messages: "Messages MTD",
    mrr: "MRR",
    created: "Created",
    owner: "Owner",
    actions: "Actions",
    rowActions: "Actions for {{tenant}}",
    usageLabel: "Messages this month for {{tenant}}",
    custom: "custom",
    showing_one: "Showing {{count}} tenant",
    showing_other: "Showing {{count}} tenants",
    showingOf_one: "Showing {{shown}} of {{count}} tenant",
    showingOf_other: "Showing {{shown}} of {{count}} tenants",
    page: "Page {{page}}",
    prev: "Prev",
    next: "Next",
    pagination: "Tenant pages",
  },
  menu: {
    view: "View tenant",
    copyId: "Copy tenant ID",
    idCopied: "Tenant ID copied",
    copyFailed: "Couldn't copy to the clipboard",
    suspend: "Suspend",
    reinstate: "Reinstate",
    delete: "Delete",
  },
  empty: {
    title: "No tenants match these filters",
    body: "Try a different plan, status or region.",
    reset: "Reset filters",
    noneTitle: "No tenants yet",
    noneBody: "Provision the first workspace and invite its owner.",
  },
  create: {
    title: "Create tenant",
    description: "Provision a workspace and invite its owner.",
    name: "Organization name",
    namePlaceholder: "e.g. Holy Angel Learning Center",
    nameInvalid: "Enter 2–120 characters.",
    ownerEmail: "Owner email",
    ownerEmailPlaceholder: "owner@organization.ph",
    ownerEmailInvalid: "Enter a valid email address.",
    industry: "Industry",
    plan: "Plan",
    planPrice: "{{plan}} — {{price}}/mo",
    planCustom: "{{plan}} — custom",
    trialDays: "Trial days",
    trialDaysHint: "LGU pilots usually get 30–60 days.",
    trialDaysInvalid: "Enter 0–90 days.",
    dataRegion: "Data region",
    regionSingapore: "ap-southeast-1 (Singapore)",
    regionOnPrem: "Philippines (on-prem / DaaS)",
    dataRegionHint: "Data Privacy Act 2012: note cross-border transfer in the DPA.",
    subdomain: "Web app address",
    subdomainPlaceholder: "holyangel",
    subdomainInvalid: "Use 3–63 lowercase letters, numbers or hyphens.",
    subdomainHint: "Leave blank to derive it from the name.",
    sendInvite: "Send invite email now",
    sendInviteHint: "Owner gets a magic link valid for 72 hours.",
    submit: "Create tenant",
    done: "Tenant created · invite sent to owner",
    doneNoInvite: "Tenant created",
  },
} as const;
